import React from "react";

interface IndexProps { }
const Index = (props: IndexProps) => {
  return <div>Pagina nova</div>;
};

export default Index;
